
import Dashboard  from './Dashboard';

export default Dashboard


// WEBPACK FOOTER //
// ./src/app/views/admin/dashboard/index.js